// extracted by mini-css-extract-plugin
export default {"closeButton":"root_close-button-module__closeButton___rXBLX"};